import React, { createContext, useState, useContext, useEffect } from "react";
import { getLanguage, loadTranslations } from "../service/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getLanguage() || "pt");
  const [translations, setTranslations] = useState({});

  // 🔹 Carrega traduções quando o idioma muda
  useEffect(() => {
    const load = async () => {
      const data = await loadTranslations(language);
      console.log("Traduções carregadas:", data);
      setTranslations(data);
    };
    load();
  }, [language]);

  // 🔹 Persiste o idioma selecionado
  useEffect(() => {
    localStorage.setItem("@GESTCORRETORLANGUAGE", language);
  }, [language]);

  // 🔹 Função de tradução
  const t = (path, fallback = "") => {
    return translations[path] || fallback || path;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
